import type { SocialPostGenerationTaskDetail } from "../types";
import { MoneyValue } from "@/components/common/money-value";

const formatUnpricedEventCount = (count: number): string =>
  count === 1 ? "1 unpriced usage event" : `${count} unpriced usage events`;

export function LlmCostPanel({ costs }: { costs: SocialPostGenerationTaskDetail["llmCosts"] }) {
  if (costs.eventCount === 0) {
    return (
      <div className="rounded-lg border bg-muted/20 px-4 py-3 text-sm text-muted-foreground">
        No LLM usage recorded yet.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {costs.unpricedEventCount > 0 ? (
        <div className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-900">
          {formatUnpricedEventCount(costs.unpricedEventCount)} could not be priced and are excluded
          from the totals below.
        </div>
      ) : null}
      {costs.byComponent.length > 0 && (
        <div className="overflow-hidden rounded-2xl border bg-card shadow-xs">
          <table className="w-full text-sm">
            <thead>
              <tr className="border-b bg-muted/40">
                <th className="px-4 py-2 text-left text-xs font-medium text-muted-foreground">
                  Component
                </th>
                <th className="px-4 py-2 text-right text-xs font-medium text-muted-foreground">
                  Calls
                </th>
                <th className="px-4 py-2 text-right text-xs font-medium text-muted-foreground">
                  Cost
                </th>
              </tr>
            </thead>
            <tbody>
              {costs.byComponent.map((item) => (
                <tr key={item.component} className="h-11 border-b last:border-b-0">
                  <td className="px-4 py-2 font-mono text-xs text-foreground">{item.component}</td>
                  <td className="px-4 py-2 text-right font-mono text-xs tabular-nums">
                    {item.eventCount}
                  </td>
                  <td className="px-4 py-2 text-right font-mono text-sm font-medium tabular-nums">
                    <div>
                      <MoneyValue amount={item.costUsd} />
                    </div>
                    {item.unpricedEventCount > 0 ? (
                      <div className="text-[11px] font-normal text-muted-foreground">
                        {formatUnpricedEventCount(item.unpricedEventCount)}
                      </div>
                    ) : null}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
